/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ISuggestedChangesQueryVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
  changeType?: Types.InputMaybe<Types.SuggestedChangeChangeTypeEnum>;
}>;

export type ISuggestedChangesQuery = {
  __typename?: 'Query';
  suggestedChanges: {
    __typename?: 'SuggestChangePage';
    nodes: Array<{
      __typename?: 'SuggestChange';
      id: string;
      payload: any;
      partyStatus?: Types.SuggestedChangeStatusEnum | null;
      status: Types.SuggestedChangeStatusEnum;
      creatorType: Types.EscrowPartyTypeEnum;
      receiverType?: Types.EscrowPartyTypeEnum | null;
      policy: { __typename?: 'SuggestedChangePolicy'; review: boolean; update: boolean };
    }>;
  };
};

export const SuggestedChangesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SuggestedChanges' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'changeType' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SuggestedChangeChangeTypeEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedChanges' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'escrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'changeType' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'changeType' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'EnumValue', value: 'pending' },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nodes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SuggestChangeFields' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SuggestChangeFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SuggestChange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'payload' } },
          { kind: 'Field', name: { kind: 'Name', value: 'partyStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'creatorType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'receiverType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'review' } },
                { kind: 'Field', name: { kind: 'Name', value: 'update' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ISuggestedChangesQuery, ISuggestedChangesQueryVariables>;
